/**
 * COPIED from pages/dev-agent/components/metadataEditor/buildCoverageMarkers.ts (no store coupling).
 * Fed by useMultiAgentIdeStore.coverageLines instead of the dev-agent store.
 */
import type { LintResult } from "@ncoder/code-editor";
import { bareClassName } from "@/pages/multi-agent/ide/utils/bareClassName";
import type { OpenFile } from "./types";

type CoverageStoreSlice = {
  className: string;
  uncovered_lines: number[];
} | null;

export function buildCoverageMarkers(
  covData: CoverageStoreSlice,
  activeFile: OpenFile | null,
): LintResult[] {
  if (
    !covData ||
    !activeFile ||
    covData.className !== bareClassName(activeFile.name)
  ) {
    return [];
  }
  const markers: LintResult[] = [];
  for (const line of covData.uncovered_lines) {
    markers.push({
      line,
      column: 1,
      endLine: line,
      endColumn: 1000,
      message: "Not covered by tests",
      severity: "warning",
    });
  }
  return markers;
}
